// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + "workshopCarousel" + "." + "3825227c3611be695ce4" + ".css";
};